import { render, staticRenderFns } from "./ImovelForm.vue?vue&type=template&id=ebdf599e&"
import script from "./ImovelForm.vue?vue&type=script&lang=js&"
export * from "./ImovelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports